<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12">
                    <div class="banner-title">新的朋友</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="content">
            <div class="item" v-for="item in applyFriends">
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="agree-btn" @click="toConfirmAdd(item)">同意</div>
                <div class="refuse-btn" @click="refuse(item)">拒绝</div>
                <div class="apply-info-box" v-if="item.applicationInformation">
                    <div class="apply-info">{{item.applicationInformation}}</div>
                </div>
            </div>
            <div class="item"
                 v-for="item in refuseFriends"
                 @touchstart="gtouchstart(item.id)"
                 @touchmove="gtouchmove()"
                 @touchend="gtouchend()"
            >
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="refuse-info">拒绝了你的邀请</div>
            </div>
            <div class="item" v-for="item in friendList"
                 @touchstart="gtouchstart(item.id)"
                 @touchmove="gtouchmove()"
                 @touchend="gtouchend()"
            >
                <img class="apply-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                <div class="apply-user">
                    <div>{{item.userName}}</div>
                </div>
                <div class="add-info">已添加</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Dialog, Toast} from 'vant';

    export default {
        name: 'applyList',
        data() {
            return {
                theme: 'light',
                defaultImg: require('@/assets/share/home/noImg.png'),
                applyFriends: [],
                refuseFriends: [],
                friendList: []
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getApplyList();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getApplyList() {
                this.$api.share.getApplyList().then(res => {
                    this.applyFriends = res.info.applyFriends;
                    this.refuseFriends = res.info.refuseFriends;
                    this.friendList = res.info.friends;
                })
            },
            toConfirmAdd(item) {
                localStorage.setItem("addUser", JSON.stringify(item));
                localStorage.setItem("remark", item.userName);
                this.$router.push({
                    name: 'confirmAddLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            gtouchstart(id) {
                // 开始触摸 长按1秒
                this.timeOutEvent = 0;
                this.timeOutEvent = setTimeout(() => {
                    Dialog.confirm({
                        message: '是否删除？',
                        getContainer: "#app",
                        confirmButtonColor: '#00BD9B',
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        cancelButtonColor: '#7F7F7F',
                    }).then(() => {
                        this.$api.share.deleteMembers({
                            id
                        }).then(res => {
                            Toast('删除成功！');
                            this.getApplyList();
                        })
                    }).catch(() => {
                        // on cancel
                    });
                }, 1000)
            },
            gtouchmove() {
                clearTimeout(this.timeOutEvent);
                this.timeOutEvent = 0
            },
            gtouchend() {
                clearTimeout(this.timeOutEvent);
                this.timeOutEvent = 0
            },
            refuse (item) {
                this.$api.share.refuseApply({
                    id: item.id
                }).then(res => {
                    Toast({message:'拒绝成功！'});
                    this.getApplyList()
                })
            }
        }
    }
</script>

<style scoped>

    .apply-icon {
        width: 30px;
        height: 30px;
        background: var(--bg-color-2);
        border: 2px solid rgba(255,255,255,0.69);
        border-radius: 50%;
        margin-left: 22px;
        margin-top: 13px;
        vertical-align: bottom;
    }

    .item {
        width: 345px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 10px;
        margin: 15px auto;
        position: relative;
        padding-bottom: 13px;
    }

    .apply-user {
        display: inline-block;
        font-size: 15px;
        color: var(--text-color-1);
        height: 32px;
        line-height: 32px;
    }

    .agree-btn {
        width: 42px;
        height: 20px;
        background: var(--bg-color-2);
        font-size: 12px;
        color: var(--text-color-1);
        position: absolute;
        top: 18px;
        right: 78px;
        text-align: center;
        line-height: 20px;
        border-radius: 5px 5px 5px 5px;
        border: 2px solid var(--text-color-1);
    }

    .refuse-btn {
        width: 42px;
        height: 20px;
        background: var(--bg-color-1);
        border-radius: 5px 5px 5px 5px;
        border: 2px solid var(--bg-color-1);
        font-size: 12px;
        color: var(--text-color-1);
        position: absolute;
        top: 18px;
        right: 20px;
        text-align: center;
        line-height: 20px;
    }

    .apply-info-box {
        width: 305px;
        height: 33px;
        background: var(--bg-color-1);
        border-radius: 6px;
        margin: 12px auto 0;
    }

    .apply-info {
        font-size: 12px;
        color: var(--text-color-1);
        padding: 10px 14px;
    }

    .refuse-info {
        position: absolute;
        right: 17px;
        top: 21px;
        color: #FF0101;
        font-size: 15px;
    }

    .add-info {
        position: absolute;
        right: 17px;
        top: 21px;
        color: #00BD9B;
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/12applyList.vue